export default __webpack_public_path__ + "static/media/a011-example2.12ec38cf.jpg";